import angular from "angular";

import SessionExpirationService from "./SessionExpirationService";
import SessionExpirationDialogController from "./SessionExpirationDialogController";

import dcModal from "modules/dc-ui/dc-modal";
import ConfigService from "app/services/ConfigService";
import Utils from "modules/dcb-eaccount/services/Utils";


export default angular.module("services.SesssionExpiration",[dcModal,ConfigService,Utils])
.factory("SessionExpirationService",SessionExpirationService)
.controller("SessionExpirationDialogController",SessionExpirationDialogController)
.name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/sessionExpiration/index.js